import Vue from 'vue';
import Vuex from 'vuex';
import config from '@/config';
import { getEcoRebatesResponse } from '@/api/ApiService';

Vue.use(Vuex);

const isUS = process.env.VUE_APP_COUNTRY === 'us';
const imgDir = process.env.NODE_ENV === 'production' ? config.IMG_DIR : '/img';
export default new Vuex.Store({
  state: {
    // Form variables
    rebatePrograms: [],
    validAvgEnergyRate: null,
    validHybridPrice: config.HYBRID_PRICE,
    validHybridInstallationPrice: config.HYBRID_INSTALLATION_PRICE,
    validZipCode: null,
    stateAbbreviation: null,
    incentiveState: null,
    isLoading: false,
    isUS,
    imgDir,
  },
  mutations: {
    setRebatePrograms(state, list) {
      state.rebatePrograms = list;
    },
    setAvgEnergyRate(state, value) {
      state.validAvgEnergyRate = value;
    },
    setValidZipCode(state, value) {
      state.validZipCode = value;
    },
    setStateAbbreviation(state, value) {
      state.stateAbbreviation = value;
    },
    setValidHybridPrice(state, value) {
      state.validHybridPrice = value;
    },
    setValidHybridInstallationPrice(state, value) {
      state.validHybridInstallationPrice = value;
    },
    setIsLoading(state, value) {
      state.isLoading = value;
    },
  },
  actions: {
    async getRebatePrograms({ commit, state }) {
      const location = isUS ? state.validZipCode : state.stateAbbreviation;
      const rebateResponse = await getEcoRebatesResponse(location);
      const rebatePrograms = config.GET_REBATE_PROGRAMS(rebateResponse);
      commit('setRebatePrograms', rebatePrograms);
    },
    setAvgEnergyRate({ commit }, value) {
      commit('setAvgEnergyRate', value);
    },
    setValidZipCode({ commit }, value) {
      commit('setValidZipCode', value);
    },
    setStateAbbreviation({ commit }, value) {
      commit('setStateAbbreviation', value);
    },
    setValidHybridPrice({ commit }, value) {
      commit('setValidHybridPrice', value);
    },
    setValidHybridInstallationPrice({ commit }, value) {
      commit('setValidHybridInstallationPrice', value);
    },
    setIsLoading({ commit }, value) {
      commit('setIsLoading', value);
    },
  },
  getters: {
    totalRebateValue: (state, getters) => {
      const value = state.rebatePrograms.reduce((acc, current) => {
        if (current.checked) {
          return acc + (current.percent ? Math.min(((current.percent * getters.hybridTotalPrice) / 100), current.value) : current.value);
        }
        return acc;
      }, 0);
      return value > 0 ? value : null;
    },
    haveRebateValues: (state) => {
      const value = state.rebatePrograms.reduce((acc, current) => (acc + current.value), 0);
      return value > 0 ? value : null;
    },
    hasFedTaxCreditWithPercentage: (state) => state.rebatePrograms.some((program) => program.checked && program.percent) || false,
    fedTaxCreditWithPercentageProgram: (state) => state.rebatePrograms.find((program) => program.checked && program.percent) || null,
    hybridTotalPrice: (state) => state.validHybridPrice + state.validHybridInstallationPrice,
    rheemPrice: (state, getters) => getters.hybridTotalPrice - getters.totalRebateValue,
  },
});
